import type { Page } from '../../types';

const criminalSanctions: Page[] = [
  {
    pageType: 'question',
    title: 'Criminal Sanctions',
    name: 'criminal-sanctions-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any criminal sanctions to declare?',
        name: 'sanctions_criminal_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Criminal Sanctions',
    name: 'criminal-sanctions',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'sanctions_criminal_instances' },
        { title: 'Total Value', field: 'sanctions_criminal' },
      ],
    },
    disabled: [
      {
        field: 'sanctions_criminal_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'sanctions_criminal_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'sanctions_criminal',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'sanctions_criminal_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default criminalSanctions;




